import React, { useMemo } from "react";
import Popover from "components/common/Popover";
import { keySeparator } from "views/Constants";
import OnClickPopoverValueGroups from "views/components/visualizations/OnClickPopover/OnClickPopoverValueGroups";
import formatValueWithUnitLabel from "views/components/visualizations/utils/formatValueWithUnitLabel";
import { getPrettifiedValue } from "views/components/visualizations/utils/unitConverters";
import getHoverSwatchColor from "views/components/visualizations/utils/getHoverSwatchColor";
const PieOnClickPopoverDropdown = ({ clickPoint, config, setFieldData }) => {
  const { rowPivotValues, columnPivotValues, metricValue } = useMemo(() => {
    var _a, _b, _c, _d, _e, _f;
    if (!clickPoint || !config) return {};
    const traceColor = getHoverSwatchColor(clickPoint);
    const splitNames = ((_a = clickPoint.data.originalName) != null ? _a : clickPoint.data.name).split(
      keySeparator
    );
    const metric = config.series.length === 1 ? config.series[0].function : splitNames.pop();
    const columnValues = splitNames.filter((value) => value !== metric);
    const columnPivotsToFields = (_c = (_b = config == null ? void 0 : config.columnPivots) == null ? void 0 : _b.flatMap((pivot) => pivot.fields)) != null ? _c : [];
    const rowPivotsToFields = (_e = (_d = config == null ? void 0 : config.rowPivots) == null ? void 0 : _d.flatMap((pivot) => pivot.fields)) != null ? _e : [];
    const splitXValues = (rowPivotsToFields == null ? void 0 : rowPivotsToFields.length) ? (_f = clickPoint.data.originalLabels) == null ? void 0 : _f[clickPoint.pointNumber].split(keySeparator) : [];
    return {
      rowPivotValues: splitXValues.map((value, i) => ({
        value,
        field: rowPivotsToFields[i],
        text: String(value),
        traceColor
      })),
      columnPivotValues: columnValues.map((value, i) => ({
        value,
        field: columnPivotsToFields[i],
        text: String(value),
        traceColor
      })),
      metricValue: {
        value: clickPoint.value,
        field: metric,
        text: `${String(clickPoint == null ? void 0 : clickPoint.value)}`,
        traceColor
      }
    };
  }, [clickPoint, config]);
  const formatedPercentageValue = useMemo(() => {
    if (!clickPoint.percent) return clickPoint.text;
    const { value, unit } = getPrettifiedValue(clickPoint.percent, { abbrev: "d%", unitType: "percent" });
    return formatValueWithUnitLabel(value, unit == null ? void 0 : unit.abbrev);
  }, [clickPoint.percent, clickPoint.text]);
  return /* @__PURE__ */ React.createElement(Popover.Dropdown, { title: formatedPercentageValue }, /* @__PURE__ */ React.createElement(
    OnClickPopoverValueGroups,
    {
      rowPivotValues,
      columnPivotValues,
      metricValue,
      setFieldData,
      config
    }
  ));
};
export default PieOnClickPopoverDropdown;
